import { Input } from '@components/Input';
import { Autocomplete as AutocompleteMui, Box, CircularProgress, IconButton, ListItem, Stack } from '@mui/material';
import { ReactComponent as SearchIcon } from '@icons/search.svg';
import { ReactComponent as CrossIcon } from '@icons/cross.svg';
import { buildDataTestIdAttribute } from '@src/utils';
import { useState } from 'react';

export const Autocomplete = ({
  multiple,
  disabled,
  value,
  options,
  loading,
  disableClearable,
  placeholder,
  onClick,
  onInputChange,
  onChange = () => {},
  inputValue,
  withSearchIcon,
  sx,
  dataTestId = '',
  showCustomClearIcon,
  inputIsClearable = true,
  ...rest
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const onBlurInput = () => {
    setIsFocused(false);
  };

  const onFocusInput = () => {
    setIsFocused(true);
  };

  return (
    <Stack width="100%">
      <AutocompleteMui
        sx={{ minWidth: '352px', ...sx }}
        multiple={multiple}
        disablePortal
        fullWidth
        disabled={disabled}
        value={value}
        options={options}
        loading={loading}
        disableClearable={disableClearable}
        getOptionLabel={(option: any) => option.label || ''}
        onInputChange={onInputChange}
        inputValue={inputValue}
        renderTags={() => ''}
        onChange={onChange}
        onClose={() => {}}
        renderOption={(props, option: any) => {
          const key = typeof option.value === 'string' ? option.value : option.key;
          return (
            <ListItem {...props} key={key} onClick={props.onClick}>
              <Stack
                direction="row"
                justifyContent="space-between"
                width="100%"
                sx={{ paddingTop: '5px', paddingBottom: '5px' }}
              >
                <Box>{option?.label}</Box>
              </Stack>
            </ListItem>
          );
        }}
        {...rest}
        renderInput={params => (
          <Input
            {...params}
            hiddenLabel
            placeholder={placeholder}
            variant="outlined"
            color="secondary"
            onBlur={onBlurInput}
            onFocus={onFocusInput}
            onClick={onClick}
            InputLabelProps={{
              style: { fontSize: '14px' },
            }}
            InputProps={{
              ...params.InputProps,
              startAdornment: withSearchIcon ? <SearchIcon style={{ marginRight: '9px' }} /> : null,
              endAdornment: (
                <>
                  {loading ? (
                    <Stack alignItems="center" paddingRight="4px">
                      <CircularProgress color="secondary" size={20} />
                    </Stack>
                  ) : null}
                  {inputValue && showCustomClearIcon && isFocused && onInputChange && inputIsClearable && (
                    <IconButton
                      onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        onInputChange(e, '');
                      }}
                      size="small"
                      sx={{ padding: 0 }}
                    >
                      <CrossIcon />
                    </IconButton>
                  )}
                  {params.InputProps?.endAdornment}
                </>
              ),
              style: {
                flexWrap: 'nowrap',
                [showCustomClearIcon ? 'overflow' : 'overflowX']: 'hidden',
              },
              inputProps: { ...params.inputProps, ...buildDataTestIdAttribute(dataTestId) },
            }}
          />
        )}
      />
    </Stack>
  );
};
